import { Box } from '@chakra-ui/react';
import Navbar from './Components/NavTest';
import About from './Page/About';
import Contact from './Page/Contact';
import Project from './Page/Project';
import Skills from './Page/Skills';
import Home from "./Page/home";
function App() {
  return (
    <Box background={'#69a0aafc'}>
      <Navbar />
          <Home id="home" />
          <About id="about" class="about section"/>
          <Skills id="skills"/>
          <Project id="projects"/>
          <Contact id="contact"/>
    </Box>
  );
}

export default App;
